import { FC } from 'react'
import {
    Container,
    VStack,
    Heading,
    Link,
    Text,
    Button,
    Icon,
    HStack,
    useColorModeValue,
} from '@chakra-ui/react'
import { Element } from 'react-scroll'
import Fade from 'react-reveal/Fade'
import Card from '../generics/Card'
import { FiArrowUpRight, FiMail } from 'react-icons/fi'

const Contact: FC = () => {
    const muted = useColorModeValue('#5a657c', '#9199a9')

    return (
        <Element name='contact'>
            <Container maxW={'8xl'} p={6.75} mt={10} mb={16}>
                <VStack spacing={6}>
                    <Fade>
                        <Heading as='h2'>Let's talk</Heading>
                    </Fade>
                    <Card maxW={'85vw'} w={'xl'} p={8}>
                        <VStack spacing={5} textAlign={'center'}>
                            <Text fontSize={'1.1rem'} lineHeight={1.6}>
                                I'm looking for ML and software engineering
                                roles, internships now and full-time starting
                                2027, where I can ship data systems and models
                                that move a real metric.
                            </Text>
                            <Text fontSize={'0.95rem'} color={muted}>
                                Best way to reach me is email or{' '}
                                <Link
                                    href='https://www.linkedin.com/in/rosiechen1005'
                                    isExternal
                                    fontWeight={600}
                                    color={useColorModeValue(
                                        'teal.700',
                                        'teal.200'
                                    )}
                                    borderBottom={
                                        '2px solid rgb(154, 228, 217)'
                                    }
                                    _hover={{ textDecor: 'none', opacity: 0.9 }}
                                >
                                    LinkedIn
                                </Link>
                                . I respond quickly.
                            </Text>
                            <HStack
                                spacing={4}
                                pt={2}
                                flexWrap='wrap'
                                justify='center'
                            >
                                <Link
                                    href='mailto:rosiechen1005@berkeley.edu'
                                    _hover={{ textDecor: 'none' }}
                                >
                                    <Button
                                        variant={'solid'}
                                        colorScheme={'cyan'}
                                        leftIcon={<Icon as={FiMail} />}
                                        rightIcon={
                                            <Icon
                                                as={FiArrowUpRight}
                                                fontSize={18}
                                                mt={'3px'}
                                            />
                                        }
                                        rounded={'full'}
                                        pb={1}
                                    >
                                        rosiechen1005@berkeley.edu
                                    </Button>
                                </Link>
                            </HStack>
                            <Text fontSize={'0.85rem'} color={muted} pt={1}>
                                Personal:{' '}
                                <Link
                                    href='mailto:chenherosalinda@gmail.com'
                                    textDecoration={'underline'}
                                >
                                    chenherosalinda@gmail.com
                                </Link>
                            </Text>
                        </VStack>
                    </Card>
                </VStack>
            </Container>
        </Element>
    )
}

export default Contact
